const theme = {
  black: "#212122",
  gray: "#f7f8f9",
  blue: "#5464f2",
  light_blue: "#b7beff",
  light_green: "#d2fa64",
  red: "#ff6c45",
};

export default theme;
